import React, { Component } from 'react';

import './Errors.css';

class PageErrorX extends Component {
  render() {
    const { variant, title, message  } = this.props;

    // eslint-disable-next-line
    const [prefix, _, sufix] = variant.split('');

    return (
      <div className="forbidden">
        <div id="error">
          <div className="error">
            <div className="error-x">
              <h1>{ prefix }<span></span>{ sufix }</h1>
            </div>
            <h2 className="pb-2">{ title }</h2>
            <p>{ message }</p>
            <a href="/app/dashboard">Ir a inicio</a>
          </div>
        </div>
      </div>
    )
  }
}

export default PageErrorX;